import * as Yup from 'yup';

export const ingDPGFIngSchema = Yup.object().shape({
	title: Yup.string().required('Veuillez renseigner un contenu'),
	unit: Yup.string().required('Veuillez renseigner une unité'),
	quantity: Yup.number().required('Veuillez renseigner une quantité'),
	total: Yup.number().required('Veuillez renseigner un prix unitaire HT'),
})
